import React from 'react';
import { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import styles from './Button.module.scss';
import clsx from 'clsx';

export type ResetButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
    AnchorHTMLAttributes<HTMLAnchorElement> & {
        as?: React.ElementType;
        className?: string;
    };

export const ResetButton = React.forwardRef<
    HTMLButtonElement | HTMLAnchorElement,
    ResetButtonProps
>(({ className, as: Component = 'button', ...rest }, ref) => {
    return <Component ref={ref} className={clsx(styles.resetButton, className)} {...rest} />;
});

ResetButton.displayName = 'ResetButton';
